<template>
    <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
        <BlogPostCard
            v-for="post in posts"
            :key="post.slug"
            :post="post"
        />
    </div>
</template>

<script setup lang="ts">
    import CMSArticle from '@/CMS/Content/Entity/CMSArticle'
    import BlogPostCard from '@/Marketing/Blog/Component/BlogPostCard.vue'

    interface BlogPostGridProps {
        posts: CMSArticle[]
    }

    defineProps<BlogPostGridProps>()
</script>
